import CoreHeaderTitle from "./CoreHeaderTitle";
import createComponentPreset from "../../../../../../fabrics/createComponentPreset";

import type { CoreHeaderTextComponentProps } from "../../types";

export const createTitleFabric = (displayName: string, testId: string) =>
    createComponentPreset<CoreHeaderTextComponentProps>(
        displayName,
        CoreHeaderTitle,
        {
            "data-tsid": testId,
        },
    );

export default createTitleFabric;
